export enum UserGroup {
  SYS_ADMIN = 'SYS_ADMIN',
  ADMIN = 'ADMIN',
  USER = 'USER'
}

export interface IUserDelete {
  email?: string;
}

export interface UserRole {
  email?: string;
  group?: UserGroup;
}

export interface IUser {
  id?: string;
  name?: string | null;
  surname?: string | null;
  account?: string | null;
  email?: string | null;
  status?: string | null;
  group?: UserGroup | null;
  note?: string | null;
  tempId?: string | null;
  cognitoUserName?: string | null;
  userSaml?: boolean;
  subtenants?: string[] | null;
}

export class User implements IUser {
  public id?: string;
  public name?: string;
  public surname?: string;
  public account?: string;
  public email?: string;
  public status?: 'ACTIVE' | 'BLOCKED';
  public group?: UserGroup;
  public note?: string;
  public tempId?: string | null;
  public cognitoUserName?: string | null;
  public userSaml?: boolean;
  public subtenants?: string[];

  constructor(fields?: Partial<IUser>) {
    Object.assign(this, fields);
  }
}